module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 0
// module chunks = 0 2 3 4 5 6 7 8 9 10 11 12 14 15 22 23 24 25 27